// extracted by mini-css-extract-plugin
export default {"sortControl":"sort_sortControl__BPIg4","sortLabel":"sort_sortLabel__vtM5a","sortSelect":"sort_sortSelect__4eBzS"};